var _rect, _path, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 16.4999C10.725 16.4999 10.4896 16.402 10.2938 16.2062C10.0979 16.0103 10 15.7749 10 15.4999V10.4124C10 10.2791 10.0271 10.152 10.0812 10.0312C10.1354 9.91033 10.2083 9.80408 10.3 9.71241L13.0125 7.01241C13.1375 6.89575 13.2854 6.82491 13.4563 6.79991C13.6271 6.77491 13.7917 6.80408 13.95 6.88741C14.1083 6.97075 14.2229 7.08741 14.2938 7.23741C14.3646 7.38741 14.3792 7.54158 14.3375 7.69991L13.775 9.99991H16.5C16.7667 9.99991 17 10.0999 17.2 10.2999C17.4 10.4999 17.5 10.7332 17.5 10.9999V11.9999C17.5 12.0582 17.4938 12.1207 17.4812 12.1874C17.4688 12.2541 17.45 12.3166 17.425 12.3749L15.925 15.8999C15.85 16.0666 15.725 16.2082 15.55 16.3249C15.375 16.4416 15.1917 16.4999 15 16.4999H11ZM8 16.4999C7.725 16.4999 7.48958 16.402 7.29375 16.2062C7.09792 16.0103 7 15.7749 7 15.4999V10.9999C7 10.7249 7.09792 10.4895 7.29375 10.2937C7.48958 10.0978 7.725 9.99991 8 9.99991C8.275 9.99991 8.51042 10.0978 8.70625 10.2937C8.90208 10.4895 9 10.7249 9 10.9999V15.4999C9 15.7749 8.90208 16.0103 8.70625 16.2062C8.51042 16.402 8.275 16.4999 8 16.4999Z",
    fill: "#CB7CFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    stroke: "#F3E0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUp);
export default __webpack_public_path__ + "static/media/thumb_up.25ed154917463eb201976ed2790086a5.svg";
export { ForwardRef as ReactComponent };